import "./Contact.css";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
  FaArrowRight
} from "react-icons/fa";

function Contact() {

  return (

    <section className="contact-section" id="contact">

      <div className="container-custom">

        {/* Heading */}

        <div className="section-heading">

          <span>CONTACT US</span>

          <h2>
            Start Your Packaging Project
          </h2>

          <p>
            Whether you need standard packaging products or a completely
            customized solution, our specialists are ready to understand
            your requirements and help you choose the right packaging.
          </p>

        </div>

        {/* Action Cards */}

        <div className="row g-4 mb-5">

          {/* Call */}

          <div className="col-lg-4">

            <a
              href="tel:+919004290293"
              className="contact-action-card"
            >

              <div className="action-icon">

                <FaPhoneAlt />

              </div>

              <h3>

                Call Our Team

              </h3>

              <p>

                Speak directly with our packaging specialists.

              </p>

              <strong>

                +91 90042 90293 | +91 77381 56675

              </strong>

              <span>

                Call Now

                <FaArrowRight />

              </span>

            </a>

          </div>

          {/* WhatsApp */}

          <div className="col-lg-4">

            <a
              href="https://wa.me/919004290293"
              target="_blank"
              rel="noreferrer"
              className="contact-action-card"
            >

              <div className="action-icon whatsapp">

                <FaWhatsapp />

              </div>

              <h3>

                WhatsApp

              </h3>

              <p>

                Get a quick response for your product enquiry.

              </p>

              <strong>

                Chat with us

              </strong>

              <span>

                Open WhatsApp

                <FaArrowRight />

              </span>

            </a>

          </div>

          {/* Email */}

          <div className="col-lg-4">

            <a
              href="mailto:sales@tigiindustries.in"
              className="contact-action-card"
            >

              <div className="action-icon">

                <FaEnvelope />

              </div>

              <h3>

                Request a Quote

              </h3>

              <p>

                Share your packaging requirement by email.

              </p>

              <strong>

                sales@tigiindustries.in <br /> tjt@tigiindustries.in

              </strong>

              <span>

                Send Email

                <FaArrowRight />

              </span>

            </a>

          </div>

        </div>

        {/* Visit Section */}

        <div className="visit-card">

          <div className="row align-items-center">

            <div className="col-lg-8">

              <span className="visit-tag">

                VISIT OUR FACILITY

              </span>

              <h3>

                TIGI Industries India Pvt. Ltd.

              </h3>

              <p>

                Plot No. 26, B Nanji Industrial Estate,
                Kharadpada, Silvassa – 396230

              </p>

              <div className="visit-info">

                <div>

                  <FaClock />

                  <span>

                    Monday – Saturday | 9:00 AM – 6:00 PM

                  </span>

                </div>

                <div>

                  <FaMapMarkerAlt />

                  <span>

                    Silvassa, Dadra & Nagar Haveli

                  </span>

                </div>

              </div>

            </div>

            <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">

              <a
                href="https://maps.google.com/?q=TIGI+Industries+India+Pvt+Ltd"
                target="_blank"
                rel="noreferrer"
                className="btn-primary-custom"
              >

                Get Directions

              </a>

            </div>

          </div>

        </div>

        {/* Map */}

        <div className="map-wrapper">

        <iframe title="TIGI Industries" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.5738695516325!2d72.96917047500885!3d20.235021281223098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be73312b4f0e073%3A0xe9e01feec57e9815!2sTIGI%20Industries%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1782832386443!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

        </div>

      </div>

    </section>

  );

}

export default Contact;